import { Component } from '@angular/core';
import { SearchBarComponent } from '../search-bar/search-bar.component';

@Component({
  selector: 'miq-auto-complete-bar',
  templateUrl: './auto-complete.component.html',
  standalone: false,
})
export class AutoCompleteComponent extends SearchBarComponent {
  suggestionSelected({ option }) {
    this.control.setValue(option.viewValue);
    if (this.props.field) {
      this.search.emit({ [this.props.field]: option.viewValue });
    } else {
      this.search.emit(option.viewValue);
    }
  }
}
